


<template>
  <div>
    <h2>Envoi du document à transmettre au client</h2>

      <div v-if="values" class="light-frame" style="display: flex; justify-content: space-between; ">
        <div style="padding: 16px 16px">
          <div class="md-headline">{{values.id_user_prenom}} {{values.id_user_nom}}</div>
          <div class="md-caption">{{values.id_user_adress_street}}, {{values.id_user_adress_city}}, {{values.id_user_adress_country}}</div>
          <div class="md-caption">{{values.id_user_mail}}</div>
          <div class="md-caption">{{values.id_user_phnum}}</div>
        </div>
      </div>
      

    <div v-for="(percent, name) in uploadingFiles">
      Téléchargement de {{name}} : {{percent}}%
    </div>

    <div v-if="documentReady" class="centered-child" style="margin-top: 48px; color: white; background-color: red">
      <div class="md-headline">Dossier déjà validé</div>
    </div>
  

    <div class="centered-child" style="margin-top: 48px">
        <div @click="onClickUpload($event)">
          <input type="file" accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                style="display: none"
                @click="fileInputClick($event)" 
                @change="fileInputChange($event)"
          >
          <md-button class="md-raised md-primary large-button" :disabled="loading">Envoyer DOCX Corrigé</md-button>
        </div>
        <div style="width: 100%; text-align: center">OU</div>
        <md-button class="md-raised md-primary large-button" @click="onClickConfirm()" :disabled="loading">Valider Doc Sans Correction</md-button>
    </div>
</div>

</template>


<script>
import ServiceAccess from '../service/ServiceAccess'

export default {

  data: function () {
    return {
      purchases: [],
      stage: null,
      values: null,
      screens: null,

      uploadingFiles: {},
      loading: false
    }
  },

  computed: {
    documentReady: function () {
      return this.stage && this.stage.name === 'document-ready'
    }
  },

  created: function () {
    global.navigationBarBus.$emit('display-save', false)

    let promises = [
      ServiceAccess.instance.purchases(this.$route.params.sessionId),
      ServiceAccess.instance.loadStage(this.$route.params.sessionId),
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      ServiceAccess.instance.loadScreens()
    ]
    Promise.all(promises).then(responses => {
      let [purchases, stage, values, screens] = responses
      this.values = values
      this.stage = stage
      this.purchases = purchases
      this.screens = screens
    })
  },


   // -----------------------------------------------------------------------

  methods: {
    onClickUpload: function (event) {
      event.currentTarget.querySelector('input').click()
    },
    fileInputClick: function (event) {
    },
    fileInputChange: function (event) {
      let files = event.target.files
      if (files.length > 0) {
        let file = files[0]
        this.fileUpload(file)
      }
    },
    uploadProgress: function (file, event) {
      this.uploadingFiles[file.name] = Math.round((event.loaded / event.total) * 100)
    },
    fileUpload: function (file) {
      this.loading = true
      let sessionId = this.$route.params.sessionId
      let sign = this.$route.params.sign
      ServiceAccess.instance.convertFileSigned(sessionId, sign, 'students.pdf', file, this.uploadProgress).then((fileResponse) => {
        delete this.uploadingFiles[file]
        this.loading = false
        let filename = fileResponse.filename 
        this.$router.push('/confirm/' + sessionId + '/' + sign + '/' + filename)
      })

    },

    onClickConfirm: function () {
      
      this.loading = true
      let sessionId = this.$route.params.sessionId
      let sign = this.$route.params.sign
      ServiceAccess.instance.convertAsciiDoc(sessionId, sign, 'students.pdf', this.uploadProgress).then((fileResponse) => {
        this.loading = false
        let filename = fileResponse.filename 
        this.$router.push('/confirm/' + sessionId + '/' + sign + '/' + filename)
      })
    }

  }
}

</script>


// WEBPACK FOOTER //
// Review.vue?76b37c50